// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"Modal_modalOverlay__3_6rz","fadeIn":"Modal_fadeIn__WDexF","modalBody":"Modal_modalBody__2DqVL"};